export default{
    setCounter(state,getters){
        return state.counter
    }
}